import { siteStats, heroImage } from "@/mocks/content";

function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function HeroSection() {
  return (
    <section id="top" className="relative pt-28 md:pt-32 pb-16 md:pb-24 bg-background-50 overflow-hidden">
      <div
        className="pointer-events-none absolute -top-24 right-0 w-[520px] h-[520px] rounded-full bg-accent-100/60 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full bg-secondary-100/50 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div data-reveal>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
              <i className="ri-fire-line" aria-hidden="true"></i>
              年轻母亲题材内容索引 · 持续整理
            </span>

            <h1 className="mt-5 font-heading font-semibold text-foreground-950 text-3xl md:text-5xl leading-tight">
              年轻的母亲在线
              <span className="block mt-2 text-2xl md:text-4xl text-primary-600">
                年轻母亲题材短剧与剧情片观看索引
              </span>
            </h1>

            <p className="mt-5 text-foreground-600 text-base md:text-lg leading-8 max-w-xl">
              本站围绕年轻母亲题材，整理短剧与剧情片的题材条目、剧情看点与观看方式说明。
              你可以在这里了解「完整版、短剧、看全集、未删减、剧情」各自的关注重点，
              再按自己的时间和喜好找到合适的方向。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => scrollToId("catalog")}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line text-lg" aria-hidden="true"></i>
                按题材开始浏览
              </button>
              <button
                type="button"
                onClick={() => scrollToId("guide")}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-guide-line text-lg" aria-hidden="true"></i>
                先看观看指南
              </button>
            </div>

            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-6">
              {siteStats.map((s) => (
                <div key={s.label}>
                  <dt className="text-xs text-foreground-500">{s.label}</dt>
                  <dd className="mt-1 font-heading font-semibold text-xl md:text-2xl text-foreground-950">
                    {s.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="relative" data-reveal>
            <div className="relative rounded-2xl overflow-hidden w-full h-[360px] md:h-[520px] bg-background-200">
              <img
                src={heroImage}
                alt="年轻母亲在窗前陪伴孩子的暖色插画"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-4 md:left-[-28px] bg-background-50 border border-background-200 rounded-xl px-5 py-4 max-w-[240px] shadow-none">
              <div className="flex items-center gap-2 text-accent-600">
                <i className="ri-sparkling-2-line" aria-hidden="true"></i>
                <span className="text-xs font-medium">本期主题</span>
              </div>
              <p className="mt-2 text-sm text-foreground-700 leading-6">
                「年轻母亲在线」聚焦年轻母亲的生活、选择与成长，用剧情呈现可被理解的日常。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}